/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Link = styled.a`
  cursor: pointer;
  text-decoration: none !important;
`;

const DownloadPdf = ({ className, href, download, nolink, children }) => {
  const A = nolink ? Link.withComponent('span') : Link;
  return (
    <A className={className} href={href} download={download}>
      { children }
    </A>
  );
};

DownloadPdf.propTypes = {
  href: PropTypes.string,
  download: PropTypes.string,
  className: PropTypes.string,
  nolink: PropTypes.bool,
  children: PropTypes.any.isRequired,
};

DownloadPdf.defaultProps = {
  href: '/downloads/Unterrichtsmaterialien_Modebewusst_komplett.pdf',
  download: 'Unterrichtsmaterialien_Modebewusst_komplett.pdf',
  className: undefined,
  nolink: false,
};

export default DownloadPdf;



// WEBPACK FOOTER //
// ./src/components/DownloadPdf/DownloadPdf.js